export function formatPrice(price) {
  return Number(price).toFixed(2).replace(".", ",");
}

export const STORE_TIME_ZONE = "Europe/Warsaw";

export function formatISODate(date) {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: STORE_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  const values = Object.fromEntries(
    parts.map(({ type, value }) => [type, value])
  );
  return `${values.year}-${values.month}-${values.day}`;
}

export function toPythonWeekday(date) {
  return (date.getDay() + 6) % 7;
}

export function formatTime(time) {
  if (typeof time !== "string" || time.length === 0) {
    return "";
  }

  return time.split(":").slice(0, 2).join(":");
}

export function orderDateFromToday(daysOffset = 0, now = new Date()) {
  const date = new Date(`${formatISODate(now)}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + daysOffset);
  return date.toISOString().slice(0, 10);
}
